// extracted by mini-css-extract-plugin
module.exports = {"pageShell":"homepage_pageShell__WskWo"};